import {getDrugTradeNames} from '@/modules/drug-catalog/functions'
import {
  useGetSupportiveMedicationDrug,
  useGetSupportiveMedicationDrugActivities,
} from '@/modules/drug-catalog/supportive-medications/api'
import {DrugCatalogItem, EventLog, TradeName} from '@cypro/engine/schema'
import {createContext, PropsWithChildren, useContext} from 'react'

interface State {
  supportiveMedicationDrug: DrugCatalogItem
  tradeNames: TradeName[]
  activities?: EventLog[]
}

interface Props extends PropsWithChildren {
  supportiveMedicationDrug: DrugCatalogItem
}

const SupportiveMedicationDrugContext = createContext<State>({} as State)

export function SupportiveMedicationDrugProvider({children, supportiveMedicationDrug: initialDrug}: Props) {
  const [supportiveMedicationDrug] = useGetSupportiveMedicationDrug(initialDrug.id)
  const [activities] = useGetSupportiveMedicationDrugActivities(initialDrug.id)

  const drug = supportiveMedicationDrug || initialDrug
  const tradeNames = getDrugTradeNames(drug)

  return (
    <SupportiveMedicationDrugContext.Provider
      value={{
        supportiveMedicationDrug: drug,
        tradeNames,
        activities,
      }}
    >
      {children}
    </SupportiveMedicationDrugContext.Provider>
  )
}

export function useSupportiveMedicationDrugContext() {
  return useContext(SupportiveMedicationDrugContext)
}
